class HeaderMegaMenu {
  constructor() {
    this.wrapper = document.querySelector('.header-mega-menu-wrapper');
    this.brandItems = document.querySelectorAll('.mega-menu__brand-item');
    this.brandContents = document.querySelectorAll('.mega-menu__brand-content');
    this.triggerElement = document.querySelector('[data-mega-menu-trigger]');

    if (!this.wrapper) return;

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupHoverBehavior();
  }

  bindEvents() {
    this.brandItems.forEach(item => {
      item.addEventListener('click', (e) => this.onBrandItemClick(e));
      item.addEventListener('mouseenter', () => this.onBrandItemHover(item));
    });

    this.wrapper.addEventListener('mouseenter', () => this.open());
    this.wrapper.addEventListener('mouseleave', () => this.close());

    if (this.triggerElement) {
      this.triggerElement.addEventListener('mouseenter', () => this.open());
      this.triggerElement.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!this.wrapper.matches(':hover')) {
            this.close();
          }
        }, 150);
      });
    }

    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target) &&
        (!this.triggerElement || !this.triggerElement.contains(e.target))) {
        this.close();
      }
    });
  }

  setupHoverBehavior() {
    let hoverTimeout;

    this.wrapper.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      this.open();
    });

    this.wrapper.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => this.close(), 150);
    });
  }

  onBrandItemClick(e) {
    if (e.target.tagName === 'A') return;
    e.preventDefault();
    const brandSlug = e.currentTarget.dataset.brand;
    this.showBrand(brandSlug);
  }

  onBrandItemHover(item) {
    const brandSlug = item.dataset.brand;
    this.showBrand(brandSlug);
  }

  showBrand(brandSlug) {
    this.brandItems.forEach(item => {
      if (item.dataset.brand === brandSlug) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    this.brandContents.forEach(content => {
      if (content.dataset.brand === brandSlug) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  open() {
    this.wrapper.classList.add('active');
    const firstBrand = this.brandItems[0];
    if (firstBrand) {
      this.showBrand(firstBrand.dataset.brand);
    }
  }

  close() {
    this.wrapper.classList.remove('active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderMegaMenu();
});
document.addEventListener('DOMContentLoaded', function () {
  const productMiniatures = document.querySelectorAll('.mega-menu__product-image-miniature');

  productMiniatures.forEach(miniature => {
    miniature.addEventListener('mouseenter', function () {
      const productImage = this.dataset.productImage;
      const productFlavor = this.dataset.productFlavor;
      const productHandle = this.dataset.productHandle;
      const selectedProduct = this.closest('.mega-menu__collection-item').querySelector('.mega-menu__collection-selected-product');
      const activeMiniature = this.closest('.mega-menu__collection-item').querySelector('.mega-menu__product-image-miniature.active');
      if (selectedProduct) {
        const imgElement = selectedProduct.querySelector('.mega-menu__collection-image');
        const containerElement = selectedProduct.querySelector('.mega-menu__collection-selected-product-container');
        for (const mini of this.closest('.mega-menu__collection-item').querySelectorAll('.mega-menu__product-image-miniature')) {
          mini.classList.remove('active');
        }
        this.classList.add('active');
        if (imgElement && productImage) {
          imgElement.src = productImage;
        }

        if (productHandle) {
          selectedProduct.href = '/products/' + productHandle;
        }

        if (containerElement) {
          containerElement.innerHTML = '';
          if (productFlavor) {
            const span = document.createElement('span');
            span.className = 'mega-menu__collection-selected-product-flavor';
            span.textContent = productFlavor;
            containerElement.appendChild(span);
          }
        }
      }
    });
  });
});
